import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	Output,
} from '@angular/core';

@Component({
	selector: 'au-linked-object-btn',
	templateUrl: './au-linked-object-btn.component.html',
	styleUrls: ['./au-linked-object-btn.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuLinkedObjectBtnComponent {
	@Input() clickable = true;
	@Input() text: string;
	@Output() clicked = new EventEmitter<MouseEvent>();

	onClick(event: MouseEvent) {
		if (!this.clickable) {
			return;
		}
		this.clicked.emit(event);
	}
}
